import { createFileRoute } from '@tanstack/react-router';
import { VisitaRelatorio } from '@/modules/agronomia/visita/components/VisitaRelatorio';

export const Route = createFileRoute('/_authed/agronomia_/visita_/$id')({
  component: VisitaRelatorioPage,
});

function VisitaRelatorioPage() {
  const { id } = Route.useParams();
  return <VisitaRelatorio id={Number(id)} />;
}
